<template>
 <v-container>
   <v-data-table
     :headers="tableHeaders"
     :items="monitoredSubs"
     class="elevation-1"
    :search="search"
    :loading="isLoading">
      <template v-slot:item.active="{ item }">
        <v-chip :color="colorFromBool(item.active)" dark small>{{item.active}}</v-chip>
      </template>
     <template v-slot:item.is_mod="{ item }">
       <v-chip :color="colorFromBool(item.is_mod)" dark small>{{item.is_mod}}</v-chip>
     </template>
     <template v-slot:item.post_permission="{ item }">
       <v-chip :color="colorFromBool(item.post_permission)" dark small>{{item.post_permission}}</v-chip>
     </template>
     <template v-slot:item.wiki_permission="{ item }">
       <v-chip :color="colorFromBool(item.wiki_permission)" dark small>{{item.wiki_permission}}</v-chip>
     </template>
     <template v-slot:item.actions="{ item }">
       <v-icon
           small
           class="mr-2"
           @click="refreshSub(item)"
       >
         mdi-refresh
       </v-icon>
       <v-icon
           small
           @click="deleteSub(item)"
       >
         mdi-delete
       </v-icon>
     </template>
   </v-data-table>
 </v-container>
</template>

<script>
import {RepositoryFactory} from "@/services/api/RepositoryFactory";

const MonitoredSubRepo = RepositoryFactory.get('monitored')
export default {
  name: "AdminMonitoredSubs",
  data: () => ({
    monitoredSubs: [],
    search: '',
    tableHeaders: [
      {text: 'Name', value: 'name'},
      {text: 'Active', value: 'active'},
      {text: 'Added', value: 'added_at'},
      {text: 'Subscribers', value: 'subscribers'},
      {text: 'Mod', value: 'is_mod'},
      {text: 'Post Perm', value: 'post_permission'},
      {text: 'Wiki Perm', value: 'wiki_permission'},
      {text: 'Actions', value: 'actions', sortable: false}
    ],
    isLoading: true
  }),
  methods: {
    loadSubs() {
      MonitoredSubRepo.getAllMonitoredSubs()
        .then(res => {
          if (res.status === 'error') {
            this.$emit('on-alert', {color: 'error', message: res.data})
            this.isLoading = false;
            return;
          }
          this.isLoading = false;
          this.monitoredSubs = res.data;
        })
    },
    deleteSub(subreddit) {
      MonitoredSubRepo.deleteMonitoredSub(subreddit.name, {params: {token: this.$store.getters.token}})
          .then(res => {
            if (res.status === 'error') {
              this.$emit('on-alert', {color: 'error', message: res.data})
              return;
            }
            let subIndex = this.monitoredSubs.findIndex(item => item.name === subreddit.name);
            if (subIndex > -1) {
              this.monitoredSubs.splice(subIndex, 1)
            }
            this.$emit('on-alert', {color: 'success', message: `Deleted ${subreddit.name}`})
          })
    },
    refreshSub(subreddit) {
      MonitoredSubRepo.refreshMonitoredSub(subreddit.name, {})
        .then(res => {
          if (res.status === 'error') {
            this.$emit('on-alert', {color: 'error', message: res.data})
            return;
          }
          let subIndex = this.monitoredSubs.findIndex(item => item.name === subreddit.name);
          if (subIndex > -1) {
            this.monitoredSubs[subIndex].subscribers = res.data.subscribers;
            this.monitoredSubs[subIndex].is_mod = res.data.is_mod;
            this.monitoredSubs[subIndex].wiki_permission = res.data.wiki_permission;
            this.monitoredSubs[subIndex].post_permission = res.data.post_permission;
          }
          this.$emit('on-alert', {color: 'success', message: `Refreshed ${subreddit.name}`})
        })
    },
    colorFromBool(value) {
      return value ? 'green' : 'red';
    }
  },
  mounted() {
    this.loadSubs();
  }
}
</script>

<style scoped>

</style>